import React from "react";
import Image from "next/image";

const LogoItem = ({ item }) => (
  <div className="flex items-center gap-2.5 flex-shrink-0 opacity-50 hover:opacity-90 transition-opacity duration-300">
    {item.logo ? (
      <Image
        src={item.logo}
        alt={item.name}
        width={item.width || 120}
        height={item.height || 32}
        className="w-auto object-contain"
        style={{ height: item.displayHeight ? `${item.displayHeight}px` : "36px" }}
      />
    ) : (
      <span className="text-[18px] font-bold text-gray-cool-700 tracking-[0.5px] whitespace-nowrap">
        {item.emoji ? `${item.emoji} ` : ""}
        {item.name}
      </span>
    )}
  </div>
);

export const ClientSection = ({
  content,
  title = "Integrates with the tools you already use",
  narrow = false,
  maxWidth,
  compact = false,
  centered = false,
}) => {
  // Support both flat arrays and nested arrays
  const items = Array.isArray(content[0]) ? content.flat() : content;

  // Duplicate for seamless infinite loop (only for marquee mode)
  const marqueeItems = [...items, ...items];

  return (
    <div className={compact ? "py-6 lg:py-8" : "py-10 lg:py-12"}>
      {title && (
        <p className="font-inter text-center text-[13px] uppercase tracking-[2px] font-semibold text-gray-cool-500 mb-7">
          {title}
        </p>
      )}
      {centered ? (
        /* Static centered layout */
        <div className="flex flex-wrap items-center justify-center gap-10 lg:gap-14 px-6">
          {items.map((item) => (
            <LogoItem key={item.name} item={item} />
          ))}
        </div>
      ) : (
        /* Marquee wrapper with gradient fades */
        <div
          className="relative overflow-hidden mx-auto w-full"
          style={maxWidth ? { maxWidth: `${maxWidth}px` } : narrow ? { maxWidth: "900px" } : undefined}
        >
          {/* Left fade */}
          <div className="absolute top-0 left-0 w-[60px] h-full bg-gradient-to-r from-white to-transparent z-[2] pointer-events-none" />
          {/* Right fade */}
          <div className="absolute top-0 right-0 w-[60px] h-full bg-gradient-to-l from-white to-transparent z-[2] pointer-events-none" />
          {/* Marquee track */}
          <div className="flex items-center gap-12 animate-marquee w-max">
            {marqueeItems.map((item, i) => (
              <LogoItem key={`${item.name}-${i}`} item={item} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
